import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import heTranslations from './he.json';
import enTranslations from './en.json';
import brTranslations from './br.json';


i18n
  .use(initReactI18next)
  .init({
    resources: {
      he: heTranslations,
      en: enTranslations,
      br: brTranslations
    },
    lng: process.env.REACT_APP_UI_LOCALE || 'en', // Default to English if not set
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;